'use strict';
var slice = [].slice;

module.exports = Groupon.DFPAds = {
  load: function() {
    var h;
    h = document.head;
    if (!(h.querySelector("meta[name='dfp-slot']") || h.querySelector("meta[name='dfp-target']"))) {
      return;
    }
    Groupon.Utils.loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
    return googletag.cmd.push(function() {
      var data, getAttrs, i, len, meta, metatags, read;
      read = function(s) {
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        try {
          s = JSON.parse(s);
        } catch (error) {}
        return s;
      };
      getAttrs = function() {
        var data, i, len, metaData, name, names, type;
        metaData = arguments[0], type = arguments[1], names = 3 <= arguments.length ? slice.call(arguments, 2) : [];
        if (metaData.name !== type) {
          return;
        }
        data = {};
        for (i = 0, len = names.length; i < len; i++) {
          name = names[i];
          try {
            data[name] = read(metaData.getAttribute("data-" + name));
          } catch (error) {}
        }
        return data;
      };
      metatags = h.getElementsByTagName('meta');
      for (i = 0, len = metatags.length; i < len; i++) {
        meta = metatags[i];
        if ((data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))) {
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads());
        } else if ((data = getAttrs(meta, 'dfp-target', 'key', 'val'))) {
          googletag.pubads().setTargeting(data.key, data.val);
        }
      }
      googletag.pubads().enableSingleRequest();
      googletag.pubads().collapseEmptyDivs();
      return googletag.enableServices();
    });
  }
};

if (!document.head.querySelector("meta[name='dfp-manual']")) {
  Groupon.DFPAds.load();
}

